<template>
    <!-- Cell for changing UTC date to local -->
    <td v-if="field.date === true" class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            item.columnClass ? item.columnClass[fieldIndex] : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]" v-html="localDateTime(thisValue, field.format)"></td>
    <!-- Cell for displaying count of items -->
    <td v-else-if="field.column === 'index'"
        class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            item.columnClass ? item.columnClass[fieldIndex] : '',
            field.columnClass ? field.columnClass : '', rowOdd ? 'even' : 'odd'
        ]">
        <span v-html="hierarchy" class="pl-3 pr-2" v-if="hierarchy !== ''"></span>
        {{ index+1 }}
    </td>
    <!-- Cell for joining column values together into one -->
    <td v-else-if="field.columns && field.join"
        v-html="thisValue.join(field.join)"
        class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]"></td>
    <!-- Cell for linking array of object values to an internal route -->
    <td v-else-if="field.array && field.linked && field.route"
        class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]">
        <span v-html="hierarchy" class="pl-3 pr-2" v-if="hierarchy !== ''"></span>
        <router-link :to="{ path: field.route.replace('{id}', item.id).replace('{slug}', item.slug).replace('{route}', item.route) }"
            v-for="(item, index) in thisValue"
            v-bind:key="index"
            class="hover:text-default-500">{{ index > 0 ? (field.join ? field.join : ', ') : '' }}{{ item[field.field] }}</router-link>
    </td>
    <!-- Cell for linking the value to an internal route -->
    <td v-else-if="field.linked && field.route && value"
        class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]">
        <span v-html="hierarchy" class="pl-3 pr-2" v-if="hierarchy !== ''"></span>
        <router-link :to="{ path: field.route.replace('{id}', field.id ? getValueByProp(item, field.id) : item.id).replace('{slug}', item.slug).replace('{route}', item.route) }"
            class="hover:text-default-500">{{ value ? value : field.default ? field.default : '' }}</router-link>
    </td>
    <!-- Cell for linking the value to an external link -->
    <td v-else-if="field.linked && field.external"
        class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]">
        <span v-html="hierarchy" class="pl-3 pr-2" v-if="hierarchy !== ''"></span>
        <a :href="value" class="hover:text-default-500" target="_blank">{{ value }}</a>
    </td>
    <!-- Cell for displaying name field from an array of objects -->
    <td v-else-if="field.array && !field.linked"
        v-html="commaSeparatedHTML"
        class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]">
    </td>
    <!-- Cell for hooking into changing ordering of items - displays up/down arrows -->
    <td v-else-if="field.order"
        class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]">
        <span v-html="hierarchy" class="pl-3 pr-2" v-if="hierarchy !== ''"></span>
        <span class="handle cursor-pointer"
            v-if="sortColumn === field.sortCol">
            <font-awesome-icon class="text-xs text-grey-darker mr-1"
                :icon="['fas', 'chevron-up']"
                v-on:click="move('moveUp', index, item)"
                v-if="index !== 0 && !hideOrdering && item.ordering !== 1" />
            <font-awesome-icon class="text-xs text-grey-darker mr-2"
                :icon="['fas', 'chevron-down']"
                v-on:click="move('moveDown', index, item)"
                v-if="!hideOrdering" />
            <span v-show="!field.hideIndex">{{ parseInt(index)+1 }}</span>
        </span>
        <span v-if="sortColumn === field.sortCol" v-show="!field.hideIndex">{{ parseInt(index)+1 }}</span>
    </td>
    <!-- Toggle cell with Icon -->
    <td v-else-if="field.icon && typeof(thisValue) === 'boolean' || field.boolean === true"
        class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]">
        <span v-html="hierarchy" class="pl-3 pr-2" v-if="hierarchy !== ''"></span>
        <font-awesome-icon class="text-lg text-green-500"
            :class="{ 'cursor-pointer': field.toggle === true }"
            :icon="['fas', 'check']"
            v-on:click="toggle('toggle', index, item, field)"
            v-if="thisValue === true || (field.boolean === true && thisValue === 1)" />
        <font-awesome-icon class="text-lg text-red-500"
            :class="{ 'cursor-pointer': field.toggle === true }"
            :icon="['fas', 'times']"
            v-on:click="toggle('toggle', index, item, field)"
            v-if="thisValue === false || (field.boolean === true && thisValue === 0)" />
    </td>
    <!-- Toggle Cell with Yes/No Text -->
    <td v-else-if="field.boolean"
        v-html="changeBoolean(thisValue, true)"
        class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]"></td>
    <!-- Icon Cell -->
    <td v-else-if="field.icon && thisValue"
        class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]">
        <span v-html="hierarchy" class="pl-3 pr-2" v-if="hierarchy !== ''"></span>
        <font-awesome-icon class="text-grey-darker mr-1"
            :icon="['fal', thisValue]" />
    </td>
    <!-- Currency -->
    <td v-else-if="field.currency" class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            item.columnClass ? item.columnClass[fieldIndex] : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]">
        <span v-tooltip="item[field.tooltip]" class="cursor-default" v-if="thisValue && thisValue !== 0">${{ thisValue.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</span>
        <span v-else>-</span>
    </td>
    <!-- Percentage -->
    <td v-else-if="field.percent" class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            item.columnClass ? item.columnClass[fieldIndex] : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]"><span v-html="thisValue ? thisValue+'%' : '-'" v-tooltip="item[field.tooltip]" class="cursor-default"></span></td>
    <!-- Cell with Colour Swatch -->
    <td v-else-if="field.colour" class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            item.columnClass ? item.columnClass[fieldIndex] : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]"><div class="p-1 text-center" :style="'background: '+item.colour.background+';'"><span :style="'color: '+item.colour.text">{{ item.colour.background }}</span></div></td>
    <!-- Toggle Cell with value -->
    <td v-else class="table-body-cell"
        :class="[
            field.align === 'center' ? 'text-center' : '',
            item.columnClass ? item.columnClass[fieldIndex] : '',
            field.columnClass ? field.columnClass : '',
            rowOdd ? 'even' : 'odd'
        ]"><span v-html="changeBoolean(thisValue)" v-tooltip="item[field.tooltip]" class="cursor-default">{{ field.default ? field.default : '' }}</span></td>
</template>

<script>
import _ from 'lodash';
import moment from "moment";

export default {
    name: 'Cell',
    props: {
        field: { type: Object, required: true },
        fieldIndex: { required: true },
        value: { required: true },
        id: { required: false, default: null },
        index: { required: true },
        item: { type: Object, required: true },
        sortColumn: { required: false },
        hideOrdering: { required: false, default: false },
        actions: { required: false, default: null }
    },
    data: function () {
        return {
            thisValue: this.value
        }
    },
    methods: {
        changeBoolean: function(value, force){
            if (value === true || (force === true && value === 1)){
                return "Yes";
            } else if (value === false || (force === true && value === 0)){
                return "No";
            } else {
                if (!value && this.field.default){
                    return this.field.default;
                }

                if (this.field.highlight) {
                    const highlight = this.getValueByProp(this.item, this.field.highlight);

                    const paddingStyle = highlight && highlight.padding ? highlight.padding : '2px 6px'

                    if (highlight && highlight.background && highlight.text){
                        return '<span style="background: ' + highlight.background + '; color: ' + highlight.text + '; padding: '+ paddingStyle +'; border-radius: 5px;">'+ value +'</span>';
                    } else if (highlight && highlight.background){
                        return '<span style="background: ' + highlight.background + '; padding: '+ paddingStyle +'; border-radius: 5px;">'+ value +'</span>';
                    } else if (highlight && highlight.text){
                        return '<span style="color: ' + highlight.text + '; padding: '+ paddingStyle +'; border-radius: 5px;">'+ value +'</span>';
                    }

                }

                return value;
            }
        },
        move: function(method, index, object){
            this.$emit('move', { method: method, index: index, item: object });
        },
        toggle: function(method, index, object, field){
            if (field.toggle && this.actions){
                if (field.allowed){
                    if (eval(field.allowed) !== -1){
                        this.$emit('toggle', { method: method, index: index, item: object, column: field.column });
                        this.thisValue = !this.thisValue;
                    }
                } else {
                    this.$emit('toggle', { method: method, index: index, item: object, column: field.column });
                    this.thisValue = !this.thisValue;
                }
            }
        },
        getValueByProp: function(item, prop, array){
            if (!prop && array){
                return array.map(arrayProp => {
                    return _.get(item, arrayProp);
                });
            } else {
                return _.get(item, prop);
            }
        },
        localDateTime(dt, format = 'DD/MM/YYYY h:mm a'){
            if (!dt){
                return '';
            }

            return moment(dt).format(format);
        },
    },
    computed: {
        commaSeparatedHTML () {
            const fieldNames = this.thisValue.map(object => {
                if (this.field.linked){
                    let url;

                    if (this.field.link){
                        url = this.field.link.replace('{id}', object.id).replace('{slug}', object.slug).replace('{route}', item.route);
                    } else {
                        url = '/'+this.field.column+'/'+object.id;
                    }

                    return '<a href="'+url+'" class="hover:text-default-500">'+object.name+'</a>';
                }
                return object.name;
            });
            return fieldNames.join(', ');
        },
        rowOdd(){
            return this.index % 2 !== 0;
        },
        hierarchy(){
            if (this.field.hierarchy){
                if (this.item.level !== 1) {
                    return '|__';
                }
            }

            return '';
        }
    }
}
</script>
